import { createAsyncAction } from 'typesafe-actions';

import {
  AggregatedTrade,
  SettlementReport,
  TransactionSettlementResponse,
} from './types';

export const getTransactionSettlement = createAsyncAction(
  'settlement/getTransactionSettlement/request',
  'settlement/getTransactionSettlement/success',
  'settlement/getTransactionSettlement/failure',
)<undefined, TransactionSettlementResponse[], undefined>();

export const setAggregatedSettlement = createAsyncAction(
  'settlement/setAggregatedSettlement/request',
  'settlement/setAggregatedSettlement/success',
  'settlement/setAggregatedSettlement/failure',
)<undefined, AggregatedTrade[], undefined>();

export const getSettlementHistory = createAsyncAction(
  'settlement/getSettlementHistory/request',
  'settlement/getSettlementHistory/success',
  'settlement/getSettlementHistory/failure',
)<undefined, SettlementReport[], undefined>();

export const getAllSettlements = createAsyncAction(
  'settlement/getAllSettlements/request',
  'settlement/getAllSettlements/success',
  'settlement/getAllSettlements/failure',
)<undefined, AggregatedTrade[], undefined>();

export const donwloadExcelSettlement = createAsyncAction(
  'settlement/donwloadExcelSettlement/request',
  'settlement/donwloadExcelSettlement/success',
  'settlement/donwloadExcelSettlement/failure',
)<undefined, undefined, undefined>();

export const donwloadPDFSettlement = createAsyncAction(
  'settlement/donwloadPDFSettlement/request',
  'settlement/donwloadPDFSettlement/success',
  'settlement/donwloadPDFSettlement/failure',
)<undefined, undefined, undefined>();

export const removeSettlement = createAsyncAction(
  'settlement/removeSettlement/request',
  'settlement/removeSettlement/success',
  'settlement/removeSettlement/failure',
)<undefined, undefined, undefined>();

export const undoSettlementHistory = createAsyncAction(
  'settlement/undoSettlementHistory/request',
  'settlement/undoSettlementHistory/success',
  'settlement/undoSettlementHistory/failure',
)<undefined, undefined, undefined>();
